import { render, staticRenderFns } from "./CrearGeneral.vue?vue&type=template&id=1b730c95&scoped=true&"
import script from "./CrearGeneral.vue?vue&type=script&lang=ts&"
export * from "./CrearGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./CrearGeneral.vue?vue&type=style&index=0&id=1b730c95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b730c95",
  null
  
)

export default component.exports